import { EForwardStatus, EForwardType } from '../types/eecs-forwards.types';

export const ForwardTypeMap = {
  [EForwardType.CREATED]: {
    name: 'Created',
    tooltip: 'The Forward was created by you',
    styles: 'bg-appCreamy text-black',
  },
  [EForwardType.ACQUIRED]: {
    name: 'Acquired',
    tooltip: 'The Forward was ordered from a counterparty',
    styles: 'bg-appLightBlue text-black',
  },
  [EForwardType.SCHEDULED]: {
    name: 'Scheduled',
    tooltip: 'The Forward was ordered by a counterparty',
    styles: 'bg-appLightGreen text-black',
  },
};

export const ForwardStatusMap = {
  [EForwardStatus.IN_PROGRESS]: {
    name: 'In Progress',
    tooltip: 'The Forward is in the process of fulfillment',
    styles: 'bg-appLightYellow text-black',
    color: '#F3FF0A',
  },
  [EForwardStatus.NO_DELIVERY]: {
    name: 'No Delivery',
    tooltip: 'The Forward has a missed delivery, 72-hour grace period applied',
    styles: 'bg-appPurple text-black',
    color: '#DB79FF',
  },
  [EForwardStatus.NO_PAYMENT]: {
    name: 'No Payment',
    tooltip: 'The Forward has a missed payment, 72-hour grace period applied',
    styles: 'bg-appOrange text-black',
    color: '#FF8A14',
  },
  [EForwardStatus.NO_CONFIRMATION]: {
    name: 'No Confirmation',
    tooltip: 'The Forward has not been confirmed',
    styles: 'bg-appDirtySand text-black',
    color: '#C3E17E',
  },
  [EForwardStatus.TERMINATED]: {
    name: 'Terminated',
    tooltip: 'The Forward was cancelled and is no longer active',
    styles: 'bg-appRed text-black',
    color: '#FE4E45',
  },
  [EForwardStatus.FULFILLED]: {
    name: 'Fulfilled',
    tooltip: 'Fulfilled',
    styles: 'bg-appOceanBlue text-black',
    color: '#A0FFE4',
  },
};
